import React, { CSSProperties, ReactElement } from 'react'
import { Wrapper } from './styles'
import NavigationMain from '../Navigation'
import Page from '@atlaskit/page'

const PageDefault = ({
  style,
  children,
  navigation,
  auth,
  ...props
}: {
  style?: CSSProperties
  children: ReactElement
  navigation: boolean
} & any) => {
  const css: CSSProperties = {
    margin: '2rem auto',
    maxWidth: '1680px',
    height: '100%',
    ...(style || {})
  }

  return (
    <Wrapper {...props} auth={auth}>
      <Page navigation={navigation === false ? null : <NavigationMain />}>
        <div style={css}>{children}</div>
      </Page>
    </Wrapper>
  )
}
export default PageDefault
